class ImageController {
    image: HTMLImageElement;
    imageUrl: string;
    private loadedPromise: Promise<Error | HTMLImageElement>;
    private resolve: (value: typeof this.image) => void;
    private reject: (reason?: Error) => void;

    constructor(imageUrl: string) {
        this.loadedPromise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
        this.imageUrl = imageUrl;
        this.loadImage(imageUrl);
    }

    private loadImage(imageUrl: string) {
        this.image = new Image();
        this.image.onload = () => {
            this.resolve(this.image);
        };
        this.image.onerror = () => {
            this.reject(new Error(`No imageProvided for ${imageUrl}`));
        };
        this.image.src = imageUrl;
        this.image.crossOrigin = 'anonymous'; // This is needed to avoid tainted canvas
    }

    getImage(): Promise<Error | HTMLImageElement> {
        return this.loadedPromise;
    }
}

export { ImageController };
